/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type billing_ExpiringBFContractDTO = {
    /**
     * AttendanceDaysPerWeek is the contracted days per week (the SBU days).
     */
    attendance_days_per_week?: number;
    beitragsfaktor?: number;
    beitragsfaktor_valid_from?: string;
    beitragsfaktor_valid_until?: string;
    child_first_name?: string;
    child_id?: string;
    child_internal_id?: string;
    child_last_name?: string;
    contract_group_id?: string;
    contract_id?: string;
    contract_number?: string;
    /**
     * DaysRemaining is negative once ValidUntil has passed.
     */
    days_remaining?: number;
    /**
     * Document is the expiring document: bf (Beitragsfaktor), sbu, or kmbb
     * (the yearly KmbB Standortgespraech protocol, #2007).
     */
    document?: billing_ExpiringBFContractDTO.document;
    /**
     * DocumentValidUntil is the latest valid-until of the matching uploaded
     * confirmation on the version's chain (#2002), absent when there is none.
     */
    document_valid_until?: string;
    /**
     * KmbbValidUntil is the version's KmbB protocol date (#2007).
     */
    kmbb_valid_until?: string;
    sbu_valid_until?: string;
    /**
     * ValidUntil is the document's last valid day on the contract version.
     */
    valid_until?: string;
};
export namespace billing_ExpiringBFContractDTO {
    /**
     * Document is the expiring document: bf (Beitragsfaktor), sbu, or kmbb
     * (the yearly KmbB Standortgespraech protocol, #2007).
     */
    export enum document {
        BF = 'bf',
        SBU = 'sbu',
        KMBB = 'kmbb',
    }
}

